<div class="dropdown-container" [ngClass]="{'active': isActiveDropdown()}" *ngIf="dataSet">
	<div [attr.data-dropdown-id]="dropdownId" class="selection text-small">
		<span class="selection-text">{{selectedItem ? selectedItem.getName() : prompt}}</span>
		<icon type="chevron-down" class="arrow-down" [attr.data-dropdown-id]="dropdownId"></icon>
	</div>

	<ul class="options text-small" *ngIf="!isGrouped" [ngClass]="{'hidden': !isActiveDropdown()}">
		<li *ngFor="let dataItem of dataSet">
			<a (click)="select(dataItem)" [ngClass]="{'active': dataItem === selectedItem}">
				{{dataItem.getName()}}
			</a>
		</li>
	</ul>

	<ul class="options text-small" *ngIf="isGrouped" [ngClass]="{'hidden': !isActiveDropdown()}">
		<li *ngFor="let groupedItem of dataSet">
			<div class="group-name">{{groupedItem.getGroupName()}}</div>
			<ul class="subgroup text-small">
				<li *ngFor="let dataItem of groupedItem.getItems()">
					<a (click)="select(dataItem)" [ngClass]="{'active': dataItem === selectedItem}">
						{{dataItem.getName()}}
					</a>
				</li>
			</ul>
		</li>
	</ul>
</div>
